import { render, staticRenderFns } from "./AddToImageGroupModal.vue?vue&type=template&id=5dde8d8a&scoped=true&"
import script from "./AddToImageGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddToImageGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddToImageGroupModal.vue?vue&type=style&index=0&id=5dde8d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde8d8a",
  null
  
)

export default component.exports